import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GlobalMessageType,
  HttpErrorHandler,
  HttpResponseStatus,
  Priority,
} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class ForbiddenHandler extends HttpErrorHandler {
  getPriority?(): Priority;

  responseStatus = HttpResponseStatus.BAD_REQUEST;

  handleError(request: HttpRequest<any>, errorResponse: HttpErrorResponse) {
    if (errorResponse.error.hasOwnProperty('errors')) {
      this.globalMessageService.add(
        errorResponse.error.errors[0].message,
        GlobalMessageType.MSG_TYPE_ERROR
      );
    } else {
       if (errorResponse.error.error_description == undefined) {
        return;
      }
      this.globalMessageService.add(
        errorResponse.error.error_description,
        GlobalMessageType.MSG_TYPE_ERROR
      );
    }
  }
}
